import React, { forwardRef, Ref } from 'react';
import { useDrop, DropTargetMonitor } from 'react-dnd';

interface DropZoneProps {
  onDrop: (item: any) => void;
  children: React.ReactNode;
}

const DropZone = forwardRef<HTMLDivElement, DropZoneProps>(
  ({ onDrop, children }, ref) => {
    const [{ isOver }, drop] = useDrop({
      accept: 'form-element',
      drop: (item: any, monitor: DropTargetMonitor) => {
        const offset = monitor.getClientOffset();
        onDrop({ ...item, offset });
      },
      collect: (monitor) => ({
        isOver: monitor.isOver(),
      }),
    });

    return (
      <div
        ref={(node) => {
          drop(node);
          if (ref) {
            if (typeof ref === 'function') {
              ref(node);
            } else if (ref !== null) {
              (ref as any).current = node;
            }
          }
        }}
        style={{ position: 'relative', minHeight: '400px' }}
      >
        {children}
        {isOver && (
          <div
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.1)',
            }}
          />
        )}
      </div>
    );
  }
);

export default DropZone;
